<template>
  <div class="notationDetail">
    <ul class="qmNav">
      <li
        v-for="(item, index) in detailList"
        :class="{ active: activeIndex == index }"
        :key="index"
        @click="turnNav(index)"
      >
        {{ item }}
      </li>
    </ul>
    <div class="content">
      <navreplyVue ref="navreplyVue" v-if="activeIndex == 0" />
      <list
        ref="list"
        :questionId="questionId"
        :type="type"
        @openEdit="openEdit"
        v-if="isRead && activeIndex == 0"
      />
      <edit
        ref="edit"
        @startKss="startKss"
        :questionId="questionId"
        :type="type"
        @openList="openList"
        v-if="!isRead && activeIndex == 0"
      />
      <nvalineVue ref="nvalineVue" :rowData="rowData" v-if="activeIndex == 1" />
    </div>
  </div>
</template>

<script>
import list from "./component/list.vue";
import navreplyVue from "@/views/project/issueMg/component/navreply.vue";
import nvalineVue from "@/views/project/issueMg/component/nvaline.vue";
import edit from "./component/edit.vue";
export default {
  props: ["type"],
  components: { list, navreplyVue, nvalineVue, edit },
  data() {
    return {
      detailList: ["内容", "活动"],
      isRead: true,
      activeIndex: 0,
      questionId: "",
      rowData: "",
    };
  },
  methods: {
    turnNav(index) {
      this.activeIndex = index;
      if (index == 0) {
        this.isRead = true;
        this.$nextTick(() => {
          this.$refs.list.show();
        });
        this.loadComment();
      }
    },
    async init(item) {
      this.activeIndex = 0;
      this.isRead = true;
      this.questionId = item.questionId;
      await this.$nextTick();
      this.$refs.list.show();
      this.loadComment();
    },
    //开启编辑
    openEdit() {
      this.isRead = false;
      this.$nextTick(() => {
        this.$refs.edit.init();
      });
    },
    //开启详情
    openList() {
      this.isRead = true;
      this.$nextTick(() => {
        this.$refs.list.show();
        this.$parent.getList();
      });
    },
    startKss(index, event) {
      this.$emit("startScreenShot", index, event);
    },
    loadComment() {
      let prjId = this.$route.query.prjId;
        let relaId2 = this.questionId;
        let questionId2 = this.questionId;
        this.$nextTick(() => {
          this.$refs.navreplyVue.showCommentInfo(
            3,
            prjId,
            1,
            relaId2,
            questionId2,
            ""
          );
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.notationDetail {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .qmNav {
    width: 100%;
    height: 45px;
    padding-top: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 2px solid #3873fe;
    li {
      width: 78px;
      height: 100%;
      text-align: center;
      line-height: 35px;
      margin: 0 10px;
      font-size: 15px;
      cursor: pointer;
    }
    li:hover {
      background: #eaeef8;
      border-radius: 6px 6px 0 0;
      color: #3873fe;
    }
    .active {
      background: #3873fe !important;
      border-radius: 6px 6px 0 0;
      color: #fff !important;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 45px);
    .footer {
      width: 100%;
      height: 45px;
    }
  }
}
</style>